import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TitleBar from "../_common/TitleBar";
import issueActions from "../../_actions/issueActions";
import mainTabActions from "../../_actions/mainTabActions";
import AlertModal from "../_common/AlertModal";

class IssueThread extends Component {
  state = {
    issuePost: "",
    showAlert_closeIssue: false
  };

  typeEnum = ["Bug", "Suggestion", "Question"];
  statusEnum = ["Open", "Resolved", "Closed"];
  statusClassEnum = ["danger", "success", "secondary"];

  handleChange_comment = e => this.setState({ issuePost: e.target.value });

  toggleAlert_closeIssue = () =>
    this.setState(prev => ({ showAlert_closeIssue: !prev.showAlert_closeIssue }));

  handleClick_closeIssue = () => {
    const { issue } = this.props;

    if (issue.issueStatusId === 2) {
      window.alert("This issue is already closed.");
      return;
    }

    this.toggleAlert_closeIssue();
  };

  handleAlert_closeIssue = alertAction => {
    const { issue, dispatch, tabId } = this.props;

    this.setState({ showAlert_closeIssue: false });

    if (alertAction === "accept") {
      dispatch(
        issueActions.editIssue({
          ...issue,
          issueStatusId: 2,
        })
      )
        .then(() => dispatch(mainTabActions.closeTab(tabId)))
        .catch(error => console.error("Error closing issue:", error));
    }
  };

  handleClick_cancel = () => {
    const { dispatch, tabId } = this.props;
    dispatch(mainTabActions.closeTab(tabId));
  };

  handleClick_submit = e => {
    const { issuePost } = this.state;
    const { issue, user, dispatch } = this.props;
    e.preventDefault();

    const issuePostDto = {
      issuePostId: 0,
      issueId: issue.issueId,
      postedOn: moment().format(),
      postedByUserId: user.userId,
      isClosingPost: false,
      isReopeningPost: false,
      isResolvedPost: false,
      bodyText: issuePost
    };


    dispatch(issueActions.addPost(issuePostDto));
    this.setState({ issuePost: "" });
  };

  getTitleBarText = () => {
    const { issue } = this.props;
    return `Issue #${issue.issueId}: Thread`;
  };

  renderStatus = () => {
    const { issue } = this.props;
    const statusClass =
      "span-bubble p-1 mr-2 bg-" + this.statusClassEnum[issue.issueStatusId];
    return (
      <span className={statusClass}>
        {this.statusEnum[issue.issueStatusId]}
      </span>
    );
  };

  renderHeader = () => {
    const { issue } = this.props;
    return (
      <React.Fragment>
        <h4 className="m-2">{`Issue #${issue.issueId} - ${issue.title}`}</h4>
        <div className="row">
          <div className="col ml-2">
            {this.renderStatus()}
            {this.typeEnum[issue.issueTypeId]} |{" "}
            <FontAwesomeIcon icon="users" className="fa-fw text-muted mx-2" />
            {issue.followers ? issue.followers.length : 0} Following
          </div>
        </div>
      </React.Fragment>
    );
  };

  renderThreadPosts = () => {
    const { issue } = this.props;
    return (
      <React.Fragment>
        <div className="card m-2">
          <div className="card-header bg-secondary text-white">
            <b>{issue.createdByUserFullName}</b> on{" "}
            {moment(issue.createdOn).format("MM/DD/YYYY h:mm:ss a")}
            <span className="ml-2 text-light">
              <small>(Original Post)</small>
            </span>
          </div>
          <div className="card-body">{issue.bodyText}</div>
        </div>
        {issue.posts &&
          _.orderBy(issue.posts, "postedOn", "asc").map((p, index) => (
            <div key={`postKey_${index}`} className="card mx-2 my-3">
              <div className="card-header">
                <b>{p.postedByUserFullName}</b> on{" "}
                {moment(p.postedOn).format("MM/DD/YYYY h:mm:ss a")}
              </div>
              <div className="card-body">{p.bodyText}</div>
              <div className="card-footer d-flex">
                <div className="mr-2">
                  <FontAwesomeIcon
                    icon={["far", "smile"]}
                    className="fa-fw pointer-cursor"
                    onClick={() => alert("Liked")}
                  />
                </div>
                <div className="mr-2">
                  <FontAwesomeIcon
                    icon={["far", "frown"]}
                    className="fa-fw text-muted"
                  />
                </div>
              </div>
            </div>
          ))}
      </React.Fragment>
    );
  };

  renderCommentBox = () => {
    const { issuePost } = this.state;
    return (
      <React.Fragment>
        <div className="card m-2">
          <div className="card-body">
            <div className="form-row">
              <label htmlFor="issuePost">
                <b>Your Response:</b>
              </label>
              <textarea
                name="issuePost"
                id="issuePost"
                className="form-control"
                onChange={this.handleChange_comment}
                value={issuePost}
                rows="5"
              />
            </div>
            <div className="form-row mt-2 d-flex justify-content-between">
              <div>
                <button
                  type="button"
                  name="closeIssue"
                  id="closeIssue"
                  className="btn btn-danger mr-2"
                  onClick={this.handleClick_closeIssue}
                >
                  Close Issue
                </button>
                <button
                  type="button"
                  name="cancel"
                  id="cancel"
                  className="btn btn-secondary"
                  onClick={this.handleClick_cancel}
                >
                  Cancel
                </button>
              </div>
              <button
                type="button"
                name="submitPost"
                id="submitPost"
                className="btn btn-primary"
                onClick={this.handleClick_submit}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    const { showAlert_closeIssue } = this.state;
    return (
      <React.Fragment>
        <TitleBar titleText={this.getTitleBarText()} />
        <div className="card m-2">
          <div className="card-body p-2 d-flex justify-content-center">
            <div className="w-75">
              {this.renderHeader()}
              <hr className="py-2 mx-2" />
              {this.renderThreadPosts()}
              {this.renderCommentBox()}
            </div>
          </div>
        </div>
        {showAlert_closeIssue && (
          <AlertModal
            alertTitle="Close Issue"
            alertTitleClass="bg-danger text-white"
            alertTitleIcon="exclamation-triangle"
            alertText="Are you sure you want to close this issue? This action will mark the issue as Closed."
            acceptCaption="Close Issue"
            acceptClass="danger"
            rejectCaption="Cancel"
            rejectClass="secondary"
            provideReject={true}
            handleAlertAction={this.handleAlert_closeIssue}
            toggleAlertModal={this.toggleAlert_closeIssue}
            showAlertModal={showAlert_closeIssue}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  issue: state.issues.openIssues[ownProps.tabId],
  user: state.authentication.user
});

export default connect(mapStateToProps)(IssueThread);
